import { render } from "./menu2.vue?vue&type=template&id=a0a0078a&scoped=true"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"

import "./menu2.vue?vue&type=style&index=0&id=a0a0078a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a0078a"]])

export default __exports__